import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const PropertyUse = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const uses = [
    { id: "primaryResidence", title: "Primary Residence" },
    { id: "secondHome", title: "Second Home" },
    { id: "investmentProperty", title: "Investment Property" },
  ];

  const checkForNextStep = () => {
    if (formData.propertyUse === "") {
      setError(true);
      console.log("error");
    }
    if (formData.propertyUse !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"80%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>How will the property be used?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">How will the property be used?</legend>
                  <div className={stepStyles.optionGroup}>
                    {uses.map((usesDescription) => (
                      <label key={usesDescription.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={usesDescription.id}
                          id={usesDescription.id}
                          name="propertyUse"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{usesDescription.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
